export default __webpack_public_path__ + "static/media/lupaSVG.1767022c.svg";